import { TFunction } from 'next-i18next'
import { Order, BigOrderItem } from 'src/core/models'

export const orderItemLinks = (orderItem: BigOrderItem, order: Order, t: TFunction) => [
  {
    label: t('Transactions.BlockchainCertificate'),
    link: orderItem.certificate,
    isDisabled: order.status !== 'paid',
    show: true,
  },
  {
    label: orderItem.is_transfer ? t('Transactions.OfficialTransferCertificate') :
      orderItem.project_kind === 'biodiversity' ? t('Transactions.Doc4') :
        t('Transactions.CompensationCertificate'),
    link: orderItem.cancellation_certificate,
    isDisabled: !orderItem.cancellation_certificate_is_valid,
    show: true,
  },
  {
    label: t('Transactions.InvoiceCertificate'),
    link: orderItem.customerInvoice ? orderItem.customerInvoice : orderItem.credit_offsetting_receipt,
    isDisabled: orderItem.customerInvoice ? false : !orderItem.credit_offsetting_receipt_is_valid,
    show: true,
  },
  {
    label: t('Transactions.TaxReliefCertificate'),
    link: orderItem.tax_relief_document,
    isDisabled: !orderItem.tax_relief_document_is_valid,
    show: orderItem.is_tax_relief
  },
  {
    label: t('Transactions.Emissions'),
    link: orderItem.emissions_reduction_purchase_agreement_certificate,
    isDisabled: false,
    show: orderItem.emissions_reduction_purchase_agreement_certificate
  },
  {
    label: t('Transactions.CFPA'),
    link: orderItem.carbon_forward_purchase_agreement_file,
    isDisabled: !orderItem.is_valid_carbon_forward_purchase_agreement_file,
    show: orderItem.project_kind === 'carbon_forward'
  },
]
